/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OriginalPricingResponse } from '../../models/original-pricing-response';

export interface GetOriginalPricing$Params {

/**
 * UUID of the product sortiment entry to retrieve original prices for
 */
  productSortimentId: string;

/**
 * If true, returns only prices relevant to the caller as a discount receiver
 */
  isRequestedAsDiscountReceiver: boolean;
}

export function getOriginalPricing(http: HttpClient, rootUrl: string, params: GetOriginalPricing$Params, context?: HttpContext): Observable<StrictHttpResponse<OriginalPricingResponse>> {
  const rb = new RequestBuilder(rootUrl, getOriginalPricing.PATH, 'post');
  if (params) {
    rb.query('productSortimentId', params.productSortimentId, {});
    rb.query('isRequestedAsDiscountReceiver', params.isRequestedAsDiscountReceiver, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OriginalPricingResponse>;
    })
  );
}

getOriginalPricing.PATH = '/pricing/original';
